<template>
  <div class="ml-5 mr-5 pb-5">
    <div>
      <NotificationMessage v-if="showNotification" :message="notificationMessage" :type="notificationType" :duration="5000"/>
    </div>

    <h4 class="titre1 mb-4 mt-4">GESTION DES REQUETES</h4>
    <div class ="container">
      <b-button id="show-modal" class="ajout mt-2" @click.prevent="showModalAdd = !showModalAdd">
      Ajouter une requête</b-button>

      <ModalAdd v-if="showModalAdd" @close="showModalAdd = false" @notification="handleNotification" class="mb-5"></ModalAdd>

      <div>
        <b-tabs active-nav-item-class="font-weight-bold text-black"
        content-class="mt-3">
          <b-tab title="Titre" active>
            <div class="search">
              <form class="form-inline" >
                <b-form-input
                  v-on:keyup.enter="searchRequetes"
                  placeholder="Titre"
                  v-model="filter"
                  debounce="200"
                  class="search"
                  type="text">
                </b-form-input>
                <b-button style=" border-color:grey" variant="light" @click.prevent="resetFilter">
                  <i class="fas fa-times"></i>
                </b-button>
                <button class="btn btn-info" @click.prevent="searchRequetes" title="Rechercher">
                  <i class="fas fa-search"></i>
                </button>
              </form>
            </div>
          </b-tab>

          <b-tab id="keyword" title="Mots clés">
            <div class="search">
              <form class="form-inline" >
                <b-form-input
                  v-on:keyup.enter="searchRequetesByKeyword"
                  placeholder="Mots clés"
                  v-model="filter"
                  debounce="200"
                  class="search"
                  type="text">
                </b-form-input>
                <b-button style=" border-color:grey" variant="light" @click.prevent="resetFilter">
                  <i class="fas fa-times"></i>
                </b-button>
                <button class="btn btn-info" @click.prevent="searchRequetesByKeyword" title="Rechercher">
                  <i class="fas fa-search"></i>
                </button>
              </form>
            </div>
          </b-tab>
        </b-tabs>
      </div>

      <b-pagination class="pagination mb-5 mt-2" v-if="requetes.length>0"
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        first-text="Début"
        last-text="Fin"
        prev-text="Précédent"
        next-text="Suivant"
        aria-controls="my-card"
        align="center">
      </b-pagination>

      <b-card
      id="my-card" bg-variant="secondary"
        v-bind:key ="requete.idRequete"
        v-for="requete in find" class="mb-3 mt-3">
          <ItemAccordionRequete
          :requeteData="requete">
          </ItemAccordionRequete>
      </b-card>

      <p class="nothing mt-4"  v-if="requetes.length<1">
        Aucune requete ne correspont à votre recherche
      </p>


      <b-pagination class="pagination mb-2" v-if="requetes.length>0"
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        first-text="Début"
        last-text="Fin"
        prev-text="Précédent"
        next-text="Suivant"
        aria-controls="my-card"
        align="center">
      </b-pagination>

    </div>
  </div>
</template>

<script>
import { ref} from 'vue';
import eventBus from '@/eventBus.js'
import useRequetesList from "@/composition/Requetes/requeteList";
import ItemAccordionRequete from "@/components/Requete/ItemAccordionRequete.vue"
import ModalAdd from "@/components/Requete/ModalAddRequete.vue"
import NotificationMessage from "@/components/Notification.vue";


  export default {
    name: "RequetesList",
    components:{
      NotificationMessage,
      ItemAccordionRequete,
      ModalAdd
    },
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    setup() {
      const requeteList = useRequetesList();
      const showModalAdd = ref(false);

      const showNotification = ref(false);
      const notificationMessage = ref("");
      const notificationType = ref("info");

      const handleNotification = ({ toastMessage, toastType }) => {
        notificationMessage.value = toastMessage;
        notificationType.value = toastType;
        showNotification.value = true;
        setTimeout(() => {
          showNotification.value = false;
        }, 5000);
      };
      eventBus.on("notification", handleNotification);

      const toggleModalAdd = () => {
        showModalAdd.value = !showModalAdd.value;
      };

      return {
        ...requeteList,
        showModalAdd,
        toggleModalAdd,
        showNotification,
        notificationMessage,
        notificationType,
        handleNotification

      };
    }
  };
</script>

<style>
.customPagination > li > button {
  color:black;
}
.afficher{
  padding-top: 1em !important;
  padding-bottom: 1em !important;
  color:black !important;
  text-align: center !important;
}
.card-body{
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.titres{
  font-size: 20px;
  padding-top: 0.5em;
  color: white;
}
.sousTitre{
  font-size: 15px;
  margin-bottom:0.5em !important;
  color: white;
}
.titre1{
  text-align:left !important;

}
.ajout{
  background-color: #f0f0f0 !important; 
  margin-bottom: 4em !important;
  color:black !important;
  font-size: 20px;
}
.ajout:hover{
  background-color:#C0C0C0 !important;
  color: white !important;
  text-decoration:none; 
}
.nav-link1{
  color: white !important;
  font-size: 15px;
  text-align: right;
  margin:auto;
  background-color: #00a3a6;
}
.nav-link1:hover{
  color: black !important;
}

.nav-link2{
  color: white !important;
  font-size: 15px;
  text-align: right;
  margin:auto;
  background-color: #ed6e6c;
}
.nav-link2:hover{
  color: black !important;
}
.nav-link3{
  color: white !important;
  font-size: 15px;
  text-align: right;
  margin:auto;
  background-color: #9dc544;
}
.nav-link3:hover{
  color: black !important;
}
.nav-link4{
  color: white !important;
  font-size: 15px;
  text-align: right;
  margin:auto;
  background-color: #275662;
}
.nav-link4:hover{
  color: black !important;
}
.form-inline{
  justify-content: center;
}
.nav-tabs{
  justify-content: center;
  border-bottom: none;
}
</style>